import React, { useState } from "react";
import { phoneWhatsapp } from "../../config/phone";

export default function ContactModal({ isOpen, onClose }) {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [assunto, setAssunto] = useState("");
    const [mensagem, setMensagem] = useState("");

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        const whatsappMessage = `Olá, tudo bem? Vim pelo site e gostaria de falar com um especialista.
*Dados do contato*
    • *Nome:* ${nome}
    • *E-mail:* ${email}
    • *Telefone:* ${telefone}

*Assunto:*
    ${assunto}

*Mensagem:*
    ${mensagem}`;

        const whatsappLink = `https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(
            whatsappMessage
        )}`;

        window.open(whatsappLink, "_blank");
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
            <div className="relative w-full max-w-[560px] max-h-[640px] rounded-[10px] bg-[#efefef] px-5 pb-5 pt-8 shadow-2xl">
                {/* Fechar */}
                <button
                    onClick={onClose}
                    className="absolute right-1 top-1 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-black transition hover:bg-black/30"
                    aria-label="Fechar"
                    type="button"
                >
                    ✕
                </button>

                {/* Topo */}
                <div className="mb-2 flex h-[30px] w-full items-center justify-center rounded-full bg-gradient-to-b from-[#4B4B4B] via-[#B5B5B5] via-[95%] to-[#FFFFFF] text-center text-[14px] font-semibold text-white md:text-[12px]">
                    Fale agora com um especialista!
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="space-y-5 bg-white rounded rounded-2xl p-4">
                        <div>
                            <label className="mb-1 block text-center text-[14px] text-black md:text-[12px]">
                                Seu nome completo
                            </label>
                            <input
                                type="text"
                                placeholder="seu nome completo"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                className="h-[30px] w-full rounded-full border-0 bg-[#dddddd] px-6 text-center text-[12px] text-gray-700 outline-none placeholder:text-[#a8a8a8]"
                            />
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label className="mb-1 block text-center text-[14px] font-medium text-black md:text-[12px]">
                                    E-mail
                                </label>
                                <input
                                    type="email"
                                    placeholder="email@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="h-[30px] w-full rounded-full border-0 bg-[#dddddd] px-6 text-center text-[12px] text-gray-700 outline-none placeholder:text-[#a8a8a8]"
                                />
                            </div>

                            <div>
                                <label className="mb-1 block text-center text-[14px] font-medium text-black md:text-[12px]">
                                    Telefone
                                </label>
                                <input
                                    type="text"
                                    placeholder="(00)00000-0000"
                                    value={telefone}
                                    onChange={(e) => setTelefone(e.target.value)}
                                    className="h-[30px] w-full rounded-full border-0 bg-[#dddddd] px-6 text-center text-[12px] text-gray-700 outline-none placeholder:text-[#a8a8a8]"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="mb-1 block text-center text-[14px] font-medium text-black md:text-[12px]">
                                Assunto
                            </label>
                            <input
                                type="text"
                                placeholder="assunto da conversa"
                                value={assunto}
                                onChange={(e) => setAssunto(e.target.value)}
                                className="h-[30px] w-full rounded-full border-0 bg-[#dddddd] px-6 text-center text-[12px] text-gray-700 outline-none placeholder:text-[#a8a8a8]"
                            />
                        </div>

                        <div>
                            <label className="mb-1 block text-center text-[14px] font-medium text-black md:text-[12px]">
                                Mensagem
                            </label>
                            <textarea
                                placeholder="envie sua mensagem"
                                value={mensagem}
                                onChange={(e) => setMensagem(e.target.value)}
                                className="h-[130px] w-full resize-none rounded-[24px] border-0 bg-[#dddddd] p-5 text-[12px] text-gray-700 outline-none placeholder:text-[#a8a8a8]"
                            />
                        </div>
                    </div>

                    <div className="flex justify-end pt-3">
                        <button
                            type="submit"
                            className="flex h-[52px] min-w-[240px] items-center justify-end gap-2 rounded-[15px] bg-gradient-to-b from-[#2fe567] to-[#2caf53] px-2 text-[14px] font-semibold text-white shadow-md transition hover:scale-[1.01]"
                        >
                            Enviar
                            <span className="flex h-10 w-10 items-center justify-center rounded-full">
                                <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M48.9177 22.5276C47.9808 10.5905 38.4095 1.01637 26.4734 0.0813477C26.3107 0.0689063 26.127 0.0555078 26.0312 0H22.9688C10.9341 0.87377 1.12738 10.1914 0.0823047 22.4548C0.0708203 22.5965 0.0411523 22.7888 0 22.9688V26.0312C0.0555078 26.127 0.0679492 26.3107 0.0813477 26.4734C1.01828 38.4076 10.5924 47.9808 22.5276 48.9177C22.6893 48.9301 22.873 48.9445 22.9688 49H26.0312C26.127 48.9445 26.3107 48.9321 26.4724 48.9196C38.4104 47.9808 47.9769 38.4095 48.9187 26.4724C48.9311 26.3107 48.9445 26.127 49 26.0312V22.9688C48.9445 22.873 48.9311 22.6893 48.9177 22.5276ZM38.7004 29.3483C35.5413 37.5482 25.9241 41.2337 18.0199 36.9835L10.2393 39.0095L12.3122 31.426C9.37603 26.3174 9.76842 19.933 13.3477 15.235C16.883 10.5934 22.8625 8.44197 28.5578 9.87082C37.1625 12.0299 41.8519 21.1695 38.7004 29.3483Z" fill="white" />
                                    <path d="M27.5931 12.1878C22.7439 11.1293 17.7587 13.162 14.9842 17.194C12.1199 21.3562 12.1065 26.816 14.9795 31.0145L13.7659 35.5327L18.3721 34.322C24.8101 38.4526 33.299 35.8044 36.2485 28.8143C39.1981 21.8222 35.0934 13.8243 27.5931 12.1878ZM32.0117 29.6297C31.1447 30.8068 29.6048 31.3657 28.1377 31.0777C24.2598 30.3149 21.4691 27.9396 19.2038 24.8283C18.5588 23.942 18.0228 23.053 17.7338 21.9954C17.2725 20.3044 17.796 18.5348 19.2191 17.4955C19.3368 17.4094 20.9245 16.9509 21.2968 17.8429L22.4864 20.6881C22.5993 20.9571 22.5773 21.2939 22.3993 21.5303L21.2892 23.0013C22.3898 25.1795 24.2139 26.8026 26.4696 27.7041C26.6189 27.7635 27.0132 27.8228 27.1146 27.7051C27.573 27.1739 27.9932 26.6591 28.4152 26.1145C28.6095 25.8628 28.9291 25.8264 29.2335 25.9738L32.4108 27.5204C32.4673 28.2286 32.4606 29.021 32.0117 29.6297Z" fill="white" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}